import { createReducer, on, Action } from '@ngrx/store';

import {
    InitOptimizelySuccess,
    OpenDownloadAppBanner,
    SetListenersErrorAction,
    SetListenersSuccessAction,
} from './AB-testing.actions';
import { ABTestingState, abTestingInitialState } from './AB-testing.state';

const ABTestingReducerDefinition = createReducer(
    abTestingInitialState,

    on(InitOptimizelySuccess, (state: ABTestingState): ABTestingState => {
        return {
            ...state,
            enabled: true,
            optimizely: {
                ...state.optimizely,
                optimizelyInitialized: true,
            },
        };
    }),

    on(SetListenersErrorAction, (state: ABTestingState): ABTestingState => {
        return {
            ...state,
            optimizely: {
                ...state.optimizely,
                listenersLoaded: false,
            },
        };
    }),

    on(SetListenersSuccessAction, (state: ABTestingState): ABTestingState => {
        return {
            ...state,
            optimizely: {
                ...state.optimizely,
                listenersLoaded: true,
            },
        };
    }),

    on(OpenDownloadAppBanner, (state: ABTestingState): ABTestingState => {
        return {
            ...state,
            optimizely: {
                ...state.optimizely,
                bannerExperiments: {
                    ...state.optimizely.bannerExperiments,
                    openDownloadAppBanner: true,
                },
            },

        };
    })
);

export function ABTestingReducer(state: ABTestingState, action: Action): ABTestingState {
    return ABTestingReducerDefinition(state, action);
}
